// TODO Review
$(() => {

    // Set CSRF token as AJAX header.
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
    });

    // @author https://stackoverflow.com/a/42529644
    // Confirm alert
    $('body').on('click', '[data-confirm]', function(event, params){

        // Send?
        if (params?.send)
            return true;

        //
        event.preventDefault();

        // Unwrap options?
        let options = $(this).data('confirm');

        if(typeof options == 'string')
            options = {
                title: options,
            };

        // Init Swal.
        Swal.fire({
            title: 'Weet u het zeker?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ja',
            confirmButtonColor: options.confirmButtonColor || '#62de43',
            cancelButtonText: 'Annuleren',
            ...options
        }).then((result) => {

            if(result.value && $(event.currentTarget).attr("href"))
                window.location.href=$(event.currentTarget).attr("href");

            else if(result.value)
                $(event.currentTarget).trigger(event.type, { 'send': true });

        });

    });

});